/**
 * CentroDeCusto
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {Carga} from '@/model/resource/Carga'
import {CentroDeCustoCollection} from '@/model/collection/CentroDeCustoCollection'

/* TODO: review generated class */
export class CentroDeCusto extends Resource {
  idCentroDeCustoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(Carga)
  cargaCentroDeCusto: Carga[] | null = null

  nome: string | null = null

  get $id() {
    return this.idCentroDeCustoPk
  }
  set $id(val) {
    this.idCentroDeCustoPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of CentroDeCusto
   */
  async getCentroDeCusto(id1: number, id2: number) {
    return await Request.get(`/admin/centro-de-custo/${id1}/${id2}`)
      .name('getCentroDeCusto')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CentroDeCusto
   */
  static async listCentroDeCusto(params: any) {
    return await Request.get(`/admin/centro-de-custo`, {params})
      .name('listCentroDeCusto')
      .as(CentroDeCustoCollection)
      .getData()
  }

  /**
   * Persists a new instance of CentroDeCusto. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCentroDeCusto() {
    return await Request.post(`/admin/centro-de-custo`, this)
      .name('persistCentroDeCusto')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CentroDeCusto to use it in a CSV file
   */
  static async listCsvCentroDeCusto(params: any) {
    return await Request.get(`/admin/centro-de-custo/csv`, {params})
      .name('listCsvCentroDeCusto')
      .as(CentroDeCustoCollection)
      .getData()
  }
}
